import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  LegacyUtility,
  Site,
  SiteRates,
  SiteTariffs,
  Utility,
  UtilityTariffs,
  Program, KeyVarElement
} from '../../domain/cloud-topology';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  availableUtilitiesUrl, chargesUrl,
  programUrl,
  sitesUrl, tariffsNameUrl, tariffsUrl, utilitiesUrl, utilityUrl
} from '../../domain/constants';
import { AuthGuardService } from '../auth-guard.service';
import { ResourceService } from '../resource.service';
import {environment} from "../../../environments/environment";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SiteService {

  constructor(private http: HttpClient) { }

  getSite(siteId: string, shallow: boolean): Observable<Site> {
    const options = {
      params: new HttpParams().set('shallow', shallow.toString())
    };
    return this.http.get(ResourceService.buildUrl([environment.topologyUrl, sitesUrl, siteId]), options).pipe(map(res => res['data']));
  }

  getPrograms(siteId: string, programType?: string): Observable<Program[]> {
    const options = {
    };

    if (programType) {
      options['params'] = new HttpParams().set('programType', programType);
    }

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, programUrl]), options).pipe(map(res => res['data']));
  }

  getTariffNames(siteId: string): Observable<SiteTariffs> {

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, tariffsNameUrl])).pipe(map(res => res['data']));
  }

  getRates(siteId: string): Observable<SiteRates> {

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, tariffsUrl])).pipe(map(res => res['data']));
  }

  getUtilityTariffs(utilityShortName: string): Observable<UtilityTariffs> {

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, utilitiesUrl, utilityShortName, tariffsUrl ])).pipe(map(res => res['data']));
  }

  getSiteTariffs(siteId: string): Observable<SiteTariffs> {

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, tariffsUrl ])).pipe(map(res => res['data']));
  }

  putSiteTariffs(siteId: string, siteTariffs: SiteTariffs): Observable<SiteTariffs> {

    return this.http.put(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, tariffsUrl ]), siteTariffs).pipe(map(res => res['data']));
  }

  putRates(siteId: string, siteRates: SiteRates): Observable<SiteRates> {

    const convertedRateObj = {
      supplyBefore: (siteRates.supplyRateBefore) ? siteRates.supplyRateBefore.key : null,
      supplyAfter: (siteRates.supplyRateAfter) ? siteRates.supplyRateAfter.key : null,
      deliveryBefore: (siteRates.deliveryRateBefore) ? siteRates.deliveryRateBefore.key : null,
      deliveryAfter: (siteRates.deliveryRateAfter) ? siteRates.deliveryRateAfter.key : null
    };

    return this.http.put(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, tariffsUrl]), convertedRateObj).pipe(map(res => res['data']));
  }

  getAvailableUtilities(siteId: string): Observable<LegacyUtility[]> {

    return this.http.get(ResourceService.buildUrl([sitesUrl, siteId, availableUtilitiesUrl])).pipe(map(res => res['data']));
  }

  getAllUtilities(): Observable<Utility[]> {

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, utilitiesUrl])).pipe(map(res => res['data']));
  }

  getUtility(siteId: string): Observable<Utility> {

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, utilityUrl])).pipe(map(res => res['data']));
  }

  putUtility(siteId: string, utilityCode): Observable<string> {
    return this.http.put(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, utilityUrl]), null, {
      params: new HttpParams().set('utility', utilityCode),
      responseType: 'text',
    }).pipe(map(res => res['data']));
  }

  getSiteCharges(siteId: string): Observable<KeyVarElement[]> {

    return this.http.get(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, chargesUrl])).pipe(map(res => res['data']));
  }


  putSiteCharges(siteId: string, charges: KeyVarElement[]) {
    return this.http.put(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, chargesUrl]), charges, {
      responseType: 'text',
    }).pipe(map(res => res['data']));
  }

  deleteSiteTariffs(siteId: string): Observable<string> {
    return this.http.delete(ResourceService.buildUrl([environment.financialUrl, sitesUrl, siteId, tariffsUrl]), {
      responseType: 'text'
    }).pipe(map(res => res['data']));
  }
}
